<template>
    <V-card elevation="5" outlined shaped>
         <v-dialog v-model="gestionModal" max-width="400" class="text-cenet">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>GESTION</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersGestion"
                  :items="datosGestion"
                  :items-per-page="5"
                  @click:row="($event, {item})=>seleccionarGestion(item)"
                  class="elevation-1"
                  id="tableId"
                  hide-default-footer
                  disable-pagination
                >
                  <!--template #[`item.actions`]="{ item }">
                    <v-icon
                      color="#0091EA"
                      small
                      class="mr-2"
                      @click="seleccionarGestion(item)"
                      title="SELECCIONAR GESTION"
                    >
                      mdi-check-circle
                    </v-icon>
                  </template-->
                </v-data-table>
              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="#EE680B"
                  @click="closeGestion"
                  style="float: right"
                  title="SALIR"
                >
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
        <div>
            <v-alert dense color="#EE680B" style="color: #ffffff">
                <h5>LISTA DE GRUPOS</h5>
            </v-alert>
        </div>
        <v-card elevation="5" outlined shaped>
            <v-card-text>
                <v-row>
                      <v-col cols="12" md="12">
               <v-btn 
             rounded
                   color="#002245"
                    class="ma-2 white--text"
                     @click="showGestion()"
                     
                    >
                  SELECCIONA TU  GESTION
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-calendar-clock-outline
              </v-icon>
           </v-btn>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="gestion"
                label="GESTION"
                disabled
                required
              ></v-text-field>
            </v-col>
                    <v-col cols="12">
                        <v-list-item>
                            <v-list-item-title class="text-center">
                                <h4>GRUPOS DISPONIBLES PARA EVALUAR</h4>
                            </v-list-item-title>
                        </v-list-item>
                        
                        <v-data-table :headers="headersGruposEstudiante" :items="datosGruposEst" 
                         @click:row="($event, {item})=>seleccionarGrupoEstudiante(item)"
                         
                            hide-default-footer disable-pagination
                            class="elevation-1" id="tableId">
                            <!--template #[`item.actions`]="{ item }">
                                <v-icon color="#0091EA" small class="mr-2" @click="seleccionarGrupoEstudiante(item)"
                                    title="SELECCIONAR GRUPO">
                                    mdi-gesture-tap
                                </v-icon>
                            </template-->

                        </v-data-table>
                    </v-col>

                    <v-col cols="12" md="12"></v-col>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="9"></v-col>
                    <!-- <v-col cols="12" md="2">
                        <v-toolbar dense shaped color="#002245">
                            <v-toolbar-title style="color: #ffffff">
                                <h6>OPCIONES</h6>
                            </v-toolbar-title>

                            <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="generateReport()"
                                style="float: left" title="REPORTE LISTA DE ESTUDIANTES">
                                <v-icon dark>mdi-printer-outline</v-icon>
                            </v-btn>
                        </v-toolbar>

                    </v-col> -->

                </v-row>

                <v-dialog v-model="modalPreguntas" max-width="1000px" max-height="100vh" >
                    <v-card>
                        <v-card-title>
                            <div style="text-align: center; width: 100%;">
                                <strong class="headline">PERCEPCIÓN ESTUDIANTIL</strong>
                            </div>
                            <v-container>
                                <v-row>
                                    <v-col>
                                        <h5 style="text-align: center">PERIODO: {{ gestion }}</h5>
                                        <h5 style="text-align: center">UNICEN - {{ sede }}</h5>
                                        <h6 style="text-align: center">Por favor, expresa tu criterio con la mayor
                                            objetividad posible
                                            en cada una
                                            de tus materias.
                                        </h6>
                                        <h6 style="text-align: center;color: #ff8000">
                                            Puntajes:<br>
                                            9 a 10 : Excelente<br>
                                            7 a 8 : Muy bueno<br>
                                            5 a 6 : Bueno<br>
                                            1 a 4 : Deficiente
                                        </h6>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-title>
                        <v-card-text style="font-size: 14px;">
                            <v-row>
                                <v-col cols="12">
                                    <!-- Recorrer cada título -->
                                    <div v-for="(titulo) in datosTitulosPercepcionEst" :key="titulo.tit">
                                        <h2>{{ titulo.tit }}</h2>
                                        <v-list>
                                            <v-list-item-group>
                                                <v-list-item
                                                    v-for="(pregunta, index) in filtrarPreguntasPorTitulo(titulo.tit)"
                                                    :key="pregunta.question">
                                                    <v-row align="center" style="width: 10%;">
                                                        <v-col cols="1">
                                                            <!-- Aquí se muestra el índice -->
                                                            <span>{{ index + 1 }}</span>
                                                            <!-- Sumar 1 para que empiece desde 1 -->
                                                        </v-col>
                                                        <v-col cols="9">
                                                            <v-list-item-content>
                                                                <v-list-item-title
                                                                    style="white-space: normal;font-size: 15px;">
                                                                    <!-- Permitir que el texto se ajuste -->
                                                                    {{ pregunta.descrip }}
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-col>
                                                        <v-col cols="2">
                                                            <v-text-field v-model="pregunta.score" type="number"
                                                                placeholder="Puntaje" style="width: 100%;"
                                                                :rules="scoreRules" min="0" ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-list-item>
                                            </v-list-item-group>
                                        </v-list>
                                    </div>
                                </v-col>
                            </v-row>
                            <!--  <v-row>
                                <v-col cols="12">
                                    <v-textarea v-model="observacion" label="Observaciones"
                                        placeholder="Ingrese aqui la actividad realizada con el docente" rows="3"
                                        auto-grow></v-textarea>
                                </v-col>
                            </v-row> -->
                        </v-card-text>
                        <v-card-actions>
                            <v-row justify="end" style="width: 100%;">
                                <v-col cols="auto">
                                    <v-btn @click="guardarRespuestas" color="#EE680B">Guardar Respuestas</v-btn>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn fab dark x-small color="red darken-1" @click="cerrarModal" title="SALIR">
                                        <v-icon dark>mdi-close-circle-outline</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="seguroModal" max-width="400" class="text-cenet">
                    <v-card elevation="5" outlined shaped>
                        <v-list-item>
                            <v-list-item-title class="text-center">
                                <h3>!Usted ya lleno la percepcion estudiantil!</h3>
                            </v-list-item-title>
                        </v-list-item>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="1"></v-col>
                                    <v-row align="center" justify="space-around">
                                        <!--                 <v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    color="success"
                    @click="enviarCuadroDesignacion()"
                    style="float: right"
                    title="ACEPTAR"
                  >
                    <v-icon dark> mdi-check-circle-outline </v-icon>
                  </v-btn> -->
                                        <v-btn class="mx-2" fab dark small color="success" @click="seguroModal = false"
                                            style="float: center" title="ENTENDIDO">
                                            <v-icon dark> mdi-check-circle-outline </v-icon>
                                        </v-btn>
                                    </v-row>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>

            </v-card-text>
        </v-card>

        <div class="text-center">
            <v-snackbar v-model="snackbarOK" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
                <strong>{{ mensajeSnackbar }}</strong>

                <template v-slot:action="{ attrs }">
                    <v-icon right v-bind="attrs" @click="snackbarOK = false">
                        mdi-close
                    </v-icon>
                </template>
            </v-snackbar>
        </div>
        <div class="text-center">
            <v-snackbar v-model="snackbarError" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
                <strong>{{ mensajeSnackbar }}</strong>

                <template v-slot:action="{ attrs }">
                    <v-icon right v-bind="attrs" @click="snackbarError = false">
                        mdi-close
                    </v-icon>
                </template>
            </v-snackbar>
        </div>
    </V-card>

</template>


<script>
import axios from "axios";
export default {
    data() {
        return {
            /* datos generales importantes */
            user: {},
            id_sede: "",
            usuario: "",
            nomus: "",
            patus: "",
            matus: "",
            materno: "",
            paterno: "",
            nombres: "",
            unicodigo: "",
            idGestion: "",
            gestion: "",
            /*  datos del estudiante */
            num_documento: "",
            fechaNaci: "",
            email: "",
            telefono: "",
            nacionalidad: "",
            direccionDocent: "",
            nombresBene: "",
            paternoBene: "",
            maternoBene: "",
            selectGenero: "",
            numDocBene: "",
            idPais: "",
            pais: "",
            datosEstudiante: [],
            datosEstcareco: [],
            datosGruposEst: [],
            datosGestionAct: [],
            datosGestion:[],
             gestionModal: 0,
            idPlanestudio: "",
            idCarrera: "",
            searchDocente: "",
            sede: "",
            seguroModal: false,

            datosPreguntasPercepcionEst: [],
            datosTitulosPercepcionEst: [],
             headersGestion: [
      { text: "GESTION", value: "nom", sortable: false, class: 'my-header-style' },
      //{ text: "OPCIONES", value: "actions", sortable: false },
    ],
            headersGruposEstudiante: [
                /*  { text: "CARRERA", value: "carrera", sortable: true }, */
               // { text: "CODIGO", value: "matcod", sortable: false,class: 'my-header-style' },
                {text: <mark> MATERIA</mark>, value: "nomat", sortable: false,class: 'my-header-style' },
                { text: <mark> DOCENTE</mark>, value: "docenombre", sortable: false,class: 'my-header-style' },
                //{ text: "OPCIONES", value: "actions", sortable: false }
            ],
            modalPreguntas: false,
            //scoreRules: [],
            scoresRules: [],
            pregunta: {
                score: null, // Inicializa el puntaje como null
            },
            respuestas: [], // Aquí almacenarás las respuestas
            snackbarError: false,


        }
    },
    created: function () {
        this.user = JSON.parse(sessionStorage.getItem("session"));
       // console.log(this.user)
        this.usuario = this.user.personal;
        this.id_sede = this.user.id_sede;
        this.nomus =
            this.user.nombres + " " + this.user.paterno + " " + this.user.materno;
        this.nombres = this.user.nombres;
        this.paterno = this.user.paterno;
        this.materno = this.user.materno;
        this.unicodigo = this.user.unico;
        this.sede = this.user.sede;
       // this.listarGestionActual();
      //  this.listarDatoEstCareco();
       // this.listarDatosEstudiante();
        this.listarTitulosPercepcionEst();
        this.listarPreguntasPercepcionEst();
    },
    methods: {
        async listarGestionActual() {
            let me = this;
            await axios
                .get(
                    "/estudiante/listargestionactual/"
                )
                .then(function (response) {
                    if (response.data.resultado == null) {
                        me.datosGestionAct = [];

                    } else {
                        me.datosGestionAct = response.data.resultado;
                        me.idGestion = me.datosGestionAct[0].id_gestion;
                        me.gestion = me.datosGestionAct[0].nom;
                        me.listarDatoEstCareco();
                    }
                })
                .catch(function (error) { });
        },
          async listarDatoEstCareco() {
            let me = this;
            await axios
                .get(
                    "/estudiante/listarEstcareco/" +
                    this.unicodigo +
                    "," +
                    this.id_sede
                )
                .then(function (response) {
                    if (response.data.resultado == null) {
                        me.datosEstcareco = [];

                    } else {
                        me.datosEstcareco = response.data.resultado;
                       // console.log(me.datosEstcareco);

                        
                    }
                })
                .catch(function (error) { });
        },
         seleccionarGestion(item) {
      this.gestion = item.nom;
      this.idGestion = item.id_gestion;
      this.gestionModal = false;
      this.llenarDatosEstcareco();
      
    },
    showGestion() {
      this.gestionModal = true;
      this.listarGestion();
    },
    closeGestion() {
      this.gestionModal = false;
    },
    async listarGestion() {
      let me = this;
      await axios
        .get("/estudiante/buscagestionactualinscr/")
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosGestion = [];
          } else {
            me.datosGestion = response.data.resultado;
            me.listarDatoEstCareco();
          }
        })
        .catch(function (error) {});
    },
        llenarDatosEstcareco() {
            this.idPlanestudio = this.datosEstcareco[0].idpla_est;
            this.idCarrera = this.datosEstcareco[0].id_carr;
          //  console.log("planestudio " + this.idPlanestudio)
            this.listarGruposEstudiante();
            this.listarDatosEstudiante();

        },
        async listarDatosEstudiante() {
            let me = this;
            await axios
                .get(
                    "/estudiante/listarDatosEst/" + this.unicodigo + "," + this.id_sede
                )
                .then(function (response) {
                    if (response.data.resultado == null) {
                        me.datosEstudiante = [];

                    } else {
                        me.datosEstudiante = response.data.resultado;
                      //  console.log(me.datosEstudiante);
                        me.llenarDatos();
                    }
                })
                .catch(function (error) { });
        },
        llenarDatos() {
            this.num_documento = this.datosEstudiante[0].numdoc;
            this.fechaNaci = this.datosEstudiante[0].fhnac;
            this.email = this.datosEstudiante[0].mail;
            this.telefono = this.datosEstudiante[0].tel;
            this.nacionalidad = this.datosEstudiante[0].tpnac;
            this.direccionDocente = this.datosEstudiante[0].dir;
            this.nombresBene = this.datosEstudiante[0].nombene;
            this.paternoBene = this.datosEstudiante[0].patbene;
            this.maternoBene = this.datosEstudiante[0].matbene;
            this.selectGenero = this.datosEstudiante[0].sex;
            this.numDocBene = this.datosEstudiante[0].numdocbene;
            this.idPais = this.datosEstudiante[0].idpai;
            this.pais = this.datosEstudiante[0].pais;
            //this.idPlanestudio=this.datosEstcareco[0].idpla_est;
            //this.idCarrera = this.datosEstcareco[0].id_carr;

        },
        
      
        async listarGruposEstudiante() {
            let me = this;
            await axios
                .get(
                    "/estudiante/gruposEstudiante/" +
                    this.unicodigo +
                    "," +
                    this.idGestion +
                    "," +
                    this.idPlanestudio +
                    "," +
                    this.id_sede
                )
                .then(function (response) {
                    if (response.data.resultado == null) {
                        me.datosGruposEst = [];
                        me.seguroModal = true;
                    } else {
                        me.datosGruposEst = response.data.resultado;
                       // console.log(me.datosGruposEst);

                    }
                })
                .catch(function (error) { });
        },

        async listarPreguntasPercepcionEst() {
            let me = this;
            await axios
                .get(
                    "/estudiante/listarPreguntasPercepcionEst/"
                )
                .then(function (response) {
                    if (response.data.resultado == null) {
                        me.datosPreguntasPercepcionEst = [];
                    } else {
                        me.datosPreguntasPercepcionEst = response.data.resultado;
                       // console.log(me.datosPreguntasPercepcionEst);

                    }
                })
                .catch(function (error) { });
        },
        async listarTitulosPercepcionEst() {
            let me = this;
            await axios
                .get(
                    "/estudiante/listarTitulosPercepcionEst/"
                )
                .then(function (response) {
                    if (response.data.resultado == null) {
                        me.datosTitulosPercepcionEst = [];
                    } else {
                        me.datosTitulosPercepcionEst = response.data.resultado;
                        //console.log(me.datosTitulosPercepcionEst)

                    }
                })
                .catch(function (error) { });
        },
        seleccionarGrupoEstudiante(item) {
            this.idGrupo = item.idgr;
            this.idMateria = item.idmat;

            this.abrirModal();
        },
        abrirModal() {
            this.scoreRules = [];
            this.modalPreguntas = true;
            this.setScoreRules();
        },
        cerrarModal() {
            this.resetScoreRules();
            this.pregunta.score = null;

            this.modalPreguntas = false;
        },
        resetScoreRules() {
            // Resetea las reglas de validación a un estado inicial
            this.scoreRules = []; // O puedes establecer reglas predeterminadas si lo deseas

        },
        setScoreRules() {
            // Establece las reglas de validación
            this.scoreRules = [
                v => v >= 1 && v <= 10 || 'El puntaje debe ser entre 1 y 10.'
            ];
        },
        filtrarPreguntasPorTitulo(titulo) {
            return this.datosPreguntasPercepcionEst.filter(pregunta => pregunta.titul === titulo);
        },
        guardarRespuestas() {
            // Limpiar el arreglo de respuestas antes de llenarlo
            this.respuestas = [];
            // Variable para almacenar errores
            let errores = [];
            // Recorrer cada título y sus preguntas
            this.datosTitulosPercepcionEst.forEach(titulo => {
                const preguntas = this.filtrarPreguntasPorTitulo(titulo.tit);
                preguntas.forEach(pregunta => {
                    // Validar que el score esté lleno y en el rango de 1 a 10
                    if (pregunta.score === null || pregunta.score === undefined || pregunta.score === '') {
                        errores.push(`El puntaje para la pregunta "${pregunta.descrip}" no puede estar vacío.`);
                        this.snackbarError = true;
                        this.mensajeSnackbar = "TODOS LAS PREGUNTAS DEBEN SER PUNTUADAS!";

                    } else if (pregunta.score < 1 || pregunta.score > 10) {
                        errores.push(`El puntaje para la pregunta "${pregunta.descrip}" debe estar entre 1 y 10.`);
                        this.snackbarError = true;
                        this.mensajeSnackbar = "EL PUNTAJE DEBE DE SER ENTRE 1 Y 10!";
                    } else {
                        // Guardar cada pregunta y su puntaje en el arreglo si es válido
                        this.respuestas.push({
                            pregunta: pregunta.descrip,
                            score: pregunta.score
                        });
                    }
                });
            });
            // Agregar la observación al arreglo de respuestas
            /* this.respuestas.push({
                observacion: this.observacion
            }); */
            // Si hay errores, mostrar un mensaje y detener el proceso
            if (errores.length > 0) {
                // Aquí puedes mostrar los errores, por ejemplo, usando un alert o un componente de notificación
                //alert(errores.join('\n'));
                return; // Detener el proceso si hay errores
            }
            // Aquí puedes continuar con el proceso de guardar las respuestas
            console.log('Respuestas guardadas:', this.respuestas);
            //this.addEvalCoordDoc();
            this.addPercepEst();
        },
        async addPercepEst() {
            try {
                console.log("entro");
                const scores = this.respuestas.map(respuesta => respuesta.score).join(",");

                //const observacion = this.respuestas.find(respuesta => respuesta.observacion).observacion;

                const response = await axios.post(
                    `/estudiante/addPercepEst/${this.unicodigo},${this.idGrupo},${this.idGestion},${this.idPlanestudio},${this.idMateria},${this.id_sede},${scores}`
                );
                this.snackbarOK = true;
                this.mensajeSnackbar = "RESPUESTAS GUARDADAS!!";
                this.listarGruposEstudiante();
                this.datosTitulosPercepcionEst.forEach(titulo => {
                    this.filtrarPreguntasPorTitulo(titulo.tit).forEach(pregunta => {
                        pregunta.score = null; // O puedes usar 0, dependiendo de tu lógica
                    });
                });
                this.cerrarModal();
            } catch (error) {
                this.snackbarError = true;
                this.mensajeSnackbar = "NO SE GUARDARON LAS RESPUESTAS LLENE TODAS LAS PREGUNTAS!";
            }
        },


    },
};
</script>
<style>
  .page-number {
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-size: 10px;
    color: #333;
  }
  .my-header-style {
   background-color: #F0F4C3 !important;
   
  }
  .img12 {
    margin: 10px;
    border-radius: 20%;
    box-shadow: 0px 0px 9px 4px #EE680B;
    animation: glow 1.5s linear infinite alternate;
  }
  mark {
  background-color: #F0F4C3;
}
  
  @keyframes glow{
    to {
      box-shadow: 0px 0px 10px 10px #002245;
    }
  }
  </style>